import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isStarted: false,
  isLoading: false,
  isDownload: false,
  totalCount: 0,
  uploadCount: 0,
  isSuccess: false,
  isError: false,
};

const uploadPhotosSlice = createSlice({
  name: "upload-photos",
  initialState,
  reducers: {
    setIsStarted(state, action) {
      state.isStarted = action.payload;
    },
    setTotalCount(state, action) {
      state.totalCount = action.payload;
    },
    setUploadCount(state, action) {
      state.uploadCount = action.payload;
    },
    setIsDownload(state, action) {
      state.isDownload = action.payload;
    },
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
  },
});

export const uploadPhotosActions = uploadPhotosSlice.actions;
export default uploadPhotosSlice;
